import React from 'react';
import { Button, Col } from 'reactstrap';

import './_style.scss';

const blackList = ['#/dashboard', '#/proposta/visualizar/', '#/'];

const BackButton = ({ forceShow }) => {
  const page = window.location.hash;
  const validShow = blackList.some((item) => page.indexOf(item) > -1)
    ? false
    : true;

  const goTo = () => {
    window.history.back();
    var url = window.location.href;
    var arr = url.split('?');

    setTimeout(() => {
      if (url.length > 1 && arr[1] && arr[1] !== '') {
        goTo();
      }
    }, 50);
  };

  return (
    <Col
      className={
        'mt-1 d-flex justify-content-end back-button ' +
        (forceShow ? 'custom' : 'default')
      }
    >
      {(!!validShow || forceShow) && (
        <div className="mb-3 ">
          <Button style={{ width: '120px' }} onClick={goTo}>
            Voltar
          </Button>
        </div>
      )}
    </Col>
  );
};

export default BackButton;
